import './PaymentComplete.scss'

import { useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Container, Row, Col } from 'react-bootstrap'

import { navigateTo } from 'components/common/navigation'
import { ROUTE_TODAY } from 'components/common/helpers/Paths'
import { getCurrentSubscription } from 'components/common/api/Payments'
import { getAuthenticatedUser } from 'components/auth'
import SubscriptionContext from 'components/common/contexts/SubscriptionContext'

import RembleLogomark from '../../../assets/images/Remble_Logomark-Green.png'
import {
  EVENT_ACTION_START,
  EVENT_CATEGORY_SUBSCRIPTION,
  saveUserEvent,
  trackGAEvent,
  trackMetaEvent
} from 'components/common/api/UserEvents'

/**
 * Simple Payment Complete component. Used to display a final summary screen after payment
 */
export default function PaymentComplete() {
  const history = useHistory()
  const user = getAuthenticatedUser()
  const { setUserSubscription } = useContext(SubscriptionContext)

  useEffect(() => {
    // Update the user's subscription context
    async function getSubscriptionAsync() {
      const sub = await getCurrentSubscription()

      // Track to Meta
      trackMetaEvent('Subscribe', {
        content_name: 'Purchased Subscription',
        currency: 'USD',
        value: sub?.plan_cost
      })

      // Track to GA
      trackGAEvent(
        'subscribe',
        'subscribe',
        'Purchased Subscription',
        '' + sub?.plan_cost,
        sub?.plan_cost
      )

      // Log the event
      await saveUserEvent(
        EVENT_CATEGORY_SUBSCRIPTION,
        EVENT_ACTION_START,
        sub?.plan_name,
        sub?.signup_code
      )
      setUserSubscription(sub)
    }
    getSubscriptionAsync()
  }, [setUserSubscription])

  return (
    <Container className='payment-complete-container'>
      <Row>
        <Col>
          <img
            className='logomark'
            src={RembleLogomark}
            alt='Remble'
            width='25'
            fetchpriority='high'
          />
          <h1 className='mt-3 title'>
            Thank you
            {user.display_name ? (
              <>
                , <span className='green'>{user.display_name}</span>
              </>
            ) : (
              ''
            )}
            !
          </h1>
          <h4>
            You have just taken one more step towards improved mental health and
            a better you.
          </h4>
          <Button
            size='lg'
            variant='primary'
            className='w-100 mt-3'
            onClick={() => navigateTo(ROUTE_TODAY, history)}
          >
            <span>Let's Remble</span>
          </Button>
        </Col>
      </Row>
    </Container>
  )
}
